<template>
  <div>
    <table class="table">
      <tbody>
      <tr class="tr-whole-border" v-if="productTable.length>0">
        <th style="width: 40px;">id</th>
        <th style="width: 72px;">상품등록일</th>
        <th style="width: 40px;">노출여부</th>
        <th style="width: 80px;">카테고리</th>
        <th style="width: 64px;">파트너명</th>
        <th style="width: 84px;">이미지</th>
        <th style="width: 80px;">상품명</th>
        <th style="width: 40px;">삭제</th>
      </tr>

      <tr v-for="(pi,idx) in productTable" :key="'product-item'+idx" class="lp-row many-field-tr">
        <td>{{ pi.id }}</td>
        <td>{{ pi.created_time }}</td>
        <td><span>{{ pi.enable_prod ? '노출함': '노출안함' }}</span></td>
        <td>{{ pi.category }}</td>
        <td style="width:60px">
          <span v-if="pi.partner">{{ pi.partner.name }}</span>
          <span v-else>-</span>
        </td>
        <td style="padding: 6px 12px;">
          <div style="text-align: center;display: inline-block"
               :style="imgField(pi.first_img)" v-if="pi.first_img"></div>
          <!-- <div :style="'background-image: url('+image(pi.img)+'); width: 60px; height: 60px; background-size: cover; background-posipion: center;'"></div> -->
        </td>
        <td>{{ pi.name }}</td>
        <td><button class="button is-danger" @click="deleteProductItem(idx)">삭제</button></td>
      </tr>

      </tbody>
    </table>
    <div class="btn-group-justify-end">
      <button class="button"
              @click="$modal.show('productListModal')">상품추가</button>
    </div>
    <modal name="productListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <product-list @productItems="productItems" page="exhibition" :selectedItems="productIdList" style="zoom: 0.85"></product-list>
    </modal>
  </div>
</template>

<script>
  import ProductList from "../ProductList";

  export default {
    components: {ProductList},
    name: "related-products",
    props: {
      products: {
        type: Array,
        required: false
      }
    },
    data () {
      return {
        productIdList: [],
        productTable: []
      }
    },
    created () {
      if(this.products.length>0) {
        this.getData();
      }
    },
    watch: {
      products (n) {
        if(this.products.length !== this.productIdList.length) {
          this.getData();
        }
      }
    },
    methods: {
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      deleteProductItem(idx){
        removeIndex(this.productTable, idx);
        removeIndex(this.productIdList, idx);
      },
      productItems(res) {
        for(let i=0; i<res.id_list.length; i++){
          if(this.productIdList.includes(res.id_list[i])===false){
            this.productTable.push(res.productItems[i]);
            this.productIdList.push(res.id_list[i]);
          }
        }
        this.$emit('update:products', this.productIdList);
        this.$modal.hide('productListModal');
      },
      async getData(){
        this.productIdList = this.products;
        if(this.productIdList.length>0) {
          this.$axios.get(`user/0/mapping/product?ids=${this.productIdList.toString()}`+
            `&fields=created_time,enable_prod,category,price,id,name,partner,first_img`).then(res=>{
            this.productTable = res.data.data;
          });
        }
      }
    }
  }
</script>

<style scoped>

</style>
